import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "header-box" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "header-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "header-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "   ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "header",
    mode: "out-in",
    id: "home"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["header", { headerColor: _ctx.headerColorFlag }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", null, [
              _createVNode(_component_router_link, { to: { name: 'Home' } }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "header-center-title"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ menuBorder: index === _ctx.getMenuIndex })
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.titleJump(item.url, index, item.menu_id))
                  }, _toDisplayString(item.name), 9, _hoisted_5)
                ], 2)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_svg_icon, {
              name: "tel",
              color: 'white'
            }),
            _hoisted_7,
            _createElementVNode("div", null, _toDisplayString(_ctx.cmsDetail.cmsTel), 1)
          ])
        ])
      ], 2), [
        [_vShow, _ctx.flag]
      ])
    ]),
    _: 1
  }))
}